/// <amd-module name="Widgets/SprintOverviewWidget/clients/WorkItemTracking" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\dashboards\widgets\sprint-overview-widget-content\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Dashboards_WorkItemTracking_Contracts from "Dashboards/Clients/Contracts/WorkItemTracking";

import { IWorkItemTrackingRestClient } from "Widgets/SprintOverviewWidget/clients/WorkItemTracking.Types";

export { IWorkItemTrackingRestClient } from "Widgets/SprintOverviewWidget/clients/WorkItemTracking.Types";

class WorkItemTrackingRestClient extends RestClientBase implements IWorkItemTrackingRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets work items for a list of work item ids (Maximum 200)
     * 
     * @param workItemGetRequest - 
     * @param project - Project ID or project name
     */
    public async getWorkItemsBatch(
        workItemGetRequest: Dashboards_WorkItemTracking_Contracts.WorkItemBatchGetRequest,
        project?: string
        ): Promise<Dashboards_WorkItemTracking_Contracts.WorkItem[]> {

        return this.beginRequest<Dashboards_WorkItemTracking_Contracts.WorkItem[]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/wit/workItemsBatch",
            routeValues: {
                project: project
            },
            body: workItemGetRequest
        });
    }

}

export const WorkItemTrackingClientName = "SprintOverviewWidget-Wit.IWorkItemTrackingRestClient";

export function getWorkItemTrackingClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IWorkItemTrackingRestClient {
    return pageContext.getRestClient<IWorkItemTrackingRestClient>(WorkItemTrackingClientName, options);
}

RestClients.add(WorkItemTrackingClientName, { 
    factory: WorkItemTrackingRestClient,
    options: {
        resourceAreaId: "5264459e-e5e0-4bd8-b118-0985e68a4ec5",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
